import { messaging, getToken, onMessage } from "./firebase";
import api from "../api/api";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export async function requestPushPermission() {
  if (!messaging) return null;
  if (!VAPID_KEY) {
    console.warn("REACT_APP_FIREBASE_VAPID_KEY not set — push notifications disabled");
    return null;
  }
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: await navigator.serviceWorker.register("/firebase-messaging-sw.js"),
    });
    return token || null;
  } catch (err) {
    console.error("Push permission error:", err);
    return null;
  }
}

export async function registerPushToken(token) {
  if (!token) return;
  try {
    await api.post("/home/push/register-token", { token, platform: "web" });
  } catch (_) {}
}

export async function unregisterPushToken(token) {
  if (!token) return;
  try {
    await api.delete("/home/push/unregister-token", { data: { token } });
  } catch (_) {}
}

export function listenForegroundMessages(callback) {
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {
    callback(payload);
  });
}
